import React from "react";

import Header from "../../components/header";
import CardInfoOption from "../../components/Health/components/cards/CardInfoOption";

import {
  ContainerInfo,
  ContainerSectionInfo,
  TextNumbers,
  TextOption,
} from "../../components/Health/components/cards/CardInfoOption/styles";
import {
  Back,
  ContainerImage,
  ContainerMain,
  Description,
  Image,
  Title,
} from "../../styles/PageStyles/Health/stylesOptionsHealth";
import { useNavigate } from "react-router-dom";
import { RoutesNames } from "../../components/utils/routes";
import useScreenSize from "../../Hooks/useScreenSize";

const OptionsHealth = () => {
  const navigate = useNavigate();
  const { width } = useScreenSize();

  const handleForm = (redirect) => {
    navigate(redirect);
  };
  return (
    <div>
      <Header />
      <ContainerMain>
        <Back onClick={() => handleForm(RoutesNames.home)}>Volver</Back>
        <Title>Salud</Title>
        <Description>
          By accessing and placing an order with UXTheme, you confirm that you are in agreement with and bound by the
          terms and conditions
        </Description>
        <ContainerImage>
          <Image src="/Health/imageHealth.png" />
        </ContainerImage>
        <CardInfoOption number="1" press={() => handleForm(RoutesNames.affiliateHealthForm)}>
          {width <= 425 ? (
            <ContainerInfo one>
              <TextNumbers style={width <= 425 ? { width: "70%", textAlign: "center" } : { textAlign: "center" }}>
                PRE-REGISTRO a la salud
              </TextNumbers>
              <TextNumbers>Recuerda:</TextNumbers>
              <TextNumbers>1. Debes tener tu documento de identidad en la mano.</TextNumbers>
              <ContainerSectionInfo>
                <TextOption>-PPT.</TextOption>
                <TextOption>-Cédula de extranjería.</TextOption>
                <TextOption>-Cédula de ciudadanía colombiana.</TextOption>
                <TextOption>-Pasaporte.</TextOption>
                <TextOption>-Salvoconducto S2 (SV).</TextOption>
                <TextOption>-Tarjeta de Identidad (T.I).</TextOption>
                <TextOption>-Registro civil de nacimiento (R.C).</TextOption>
              </ContainerSectionInfo>
              <TextNumbers>2. Llena el formulario, carga el documento y ¡listo!.</TextNumbers>
              <TextNumbers>
                3. Debes seguir cargando cada 4 meses el certificado de residencia, del municipio donde estas viviendo,
                sino lo haces pierdes la afiliación.
              </TextNumbers>
              <TextNumbers style={{ textAlign: "center", color: "rgba(0, 10, 255, 0.5)" }}>
                ¡¡¡ Tienes derecho a la salud, así que inscríbase, es muy fácil !!!
              </TextNumbers>
            </ContainerInfo>
          ) : (
            <>
              <ContainerInfo>
                <TextNumbers style={{ textAlign: "center" }}>PRE-REGISTRO a la salud</TextNumbers>
                <TextNumbers>Recuerda:</TextNumbers>
                <TextNumbers>1. Debes tener tu documento de identidad en la mano.</TextNumbers>
                <ContainerSectionInfo>
                  <TextOption>-PPT.</TextOption>
                  <TextOption>-Cédula de extranjería.</TextOption>
                  <TextOption>-Cédula de ciudadanía colombiana.</TextOption>
                  <TextOption>-Pasaporte.</TextOption>
                  <TextOption>-Salvoconducto S2 (SV).</TextOption>
                  <TextOption>-Tarjeta de Identidad (T.I).</TextOption>
                  <TextOption>-Registro civil de nacimiento (R.C).</TextOption>
                </ContainerSectionInfo>
              </ContainerInfo>
              <ContainerInfo>
                <TextNumbers>2. Llena el formulario, carga el documento y ¡listo!.</TextNumbers>
                <TextNumbers>
                  3. Debes seguir cargando cada 4 meses el certificado de residencia, del municipio donde estas
                  viviendo, sino lo haces pierdes la afiliación.
                </TextNumbers>
                <TextNumbers style={{ textAlign: "center", color: "rgba(0, 10, 255, 0.5)" }}>
                  ¡¡¡ Tienes derecho a la salud, así que inscríbase, es muy fácil !!!
                </TextNumbers>
              </ContainerInfo>
            </>
          )}
        </CardInfoOption>
        <CardInfoOption number="2" firstColor="#FFA13B" secondColor="#E8811A">
          <ContainerInfo one>
            <TextNumbers style={width <= 425 ? { width: "70%", textAlign: "center" } : { textAlign: "center" }}>
              Cargar certificado de residencia
            </TextNumbers>
            <TextNumbers>Recuerda:</TextNumbers>
            <TextNumbers>
              1. Debes tener a la mano la cuenta de servicios públicos de tu lugar de residencia o el documento que
              evidencie tu lugar de residencia.
            </TextNumbers>
            <TextNumbers />
            <TextNumbers />
            <TextNumbers
              style={{
                marginLeft: "20%",
                textAlign: "center",
                color: "rgba(0, 10, 255, 0.5)",
              }}
              blue
            >
              ¡¡¡ Mantener vigente la afiliación a la salud, es Tú responsabilidad y Tú mejor decisión !!!
            </TextNumbers>
          </ContainerInfo>
        </CardInfoOption>
      </ContainerMain>
    </div>
  );
};

export default OptionsHealth;
